import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useCallback,
} from "react";
import { useSelector } from "react-redux";
import axios from "axios";
// import { useNavigate } from "react-router-dom";
import { useStyletron } from "baseui";
// import { Grid, Cell } from "baseui/layout-grid";
// import { Modal, ModalHeader, ModalBody /* , SIZE */ } from "baseui/modal";
import {
  StatefulDataTable,
  StringColumn,
  CustomColumn,
} from "baseui/data-table";
// import { styled, Theme } from "baseui";
import { Button } from "baseui/button"; // Import Button
import { Checkbox } from "baseui/checkbox";
import EditInspectModal from "./editInspectModal";
import InitInspectsModal from "./initInspectsModal";
import IncomingTableAdmin from "../../incomingTableAdmin";
import { SIZE } from "baseui/button-group";

// import IncomingTable from "../../incomingTable";

// const HighlightedRow = styled("div", ({ $isHighlighted, $theme }) => ({
//   backgroundColor: $isHighlighted ? $theme.colors.warning200 : "transparent",
//   ":hover": {
//     backgroundColor: $isHighlighted
//       ? $theme.colors.warning400
//       : $theme.colors.backgroundSecondary,
//     cursor: "pointer",
//   },
// }));

const Inspections = forwardRef((props, ref) => {
  const { nonAdmin } = props;
  const [emptyMessageLocations, setEmptyMessageLocations] = useState([]);

  const user = useSelector((state) => state.user);

  // const state = useSelector((state) => state);
  // const userRole = user.role_id;
  const [highlightedSteps, setHighlightedSteps] = useState([]);

  const apiUrl = process.env.REACT_APP_API_URL;

  const [css] = useStyletron();
  // const navigate = useNavigate();
  const [inspectionData, setInspectionData] = useState([]);
  const [fetchedInventory, setFetchedInventory] = useState([]);
  const [inventoryMap, setInventoryMap] = useState({ byId: {}, byStock: {} });
  const [customerMap, setCustomerMap] = useState({});
  const [stepsMap, setStepsMap] = useState({}); //step_name strings
  const [userMap, setUserMap] = useState({}); //user 'first_name + last_name' strings

  const [locationMap3, setLocationMap3] = useState({
    1: "Diberville",
    2: "Douglasville",
    3: "Montgomery",
    4: "Birmingham",
  });

  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
  const [editInspectOpen, setEditInspectOpen] = useState(false);
  const [matchingInitRows, setMatchingInitRows] = useState([]);
  const [editInspectionObj, setEditInspectionObj] = useState();

  const [selectedInspectionTypes, setSelectedInspectionTypes] = useState([]);
  // const [selectedNextStatusTypes, setSelectedNextStatusTypes] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [excludeAssignRepair, setExcludeAssignRepair] = useState(false);
  const [repairsOnly, setRepairsOnly] = useState(false);
  //for admin repair table
  const [locationLabel, setLocationLabel] = useState("");

  const retrieveLoginLocationId = async () => {
    const storedLocation = localStorage.getItem("location");
    if (storedLocation) {
      try {
        const parsedLocation = JSON.parse(storedLocation);
        if (parsedLocation[0] && parsedLocation[0].id) {
          setLocationLabel(parsedLocation[0].label);
        } else {
          console.warn("Location ID not found in stored location.");
        }
      } catch (error) {
        console.error("Error parsing location from localStorage:", error);
      }
    } else {
      console.warn("No location found in localStorage.");
    }
  };

  useEffect(() => {
    retrieveLoginLocationId();
  }, []);

  // console.log("editInspectionObject", editInspectionObj);
  //CREATES USER NAME STRINGS
  const createUserMap = (usersData) => {
    return usersData.reduce((map, user) => {
      map[user.id] = `${user.first_name} ${user.last_name}`;
      return map;
    }, {});
  };

  const normalizeStock = (value) => String(value || "").trim().toLowerCase();

  const createInventoryMap = (invData) => {
    const mapById = {};
    const mapByStock = {};

    invData.forEach((vehicle) => {
      const stockValue = vehicle.stock || vehicle.Stock;
      const year = vehicle.year || vehicle.Year;
      const make = vehicle.make || vehicle.Make;
      const model = vehicle.model || vehicle.Model;
      const color = vehicle.color || vehicle.Color;
      const vehicleString = [year, make, model].filter(Boolean).join(" ").trim();
      const label =
        vehicleString.length > 0
          ? color
            ? `${vehicleString} (${color})`
            : vehicleString
          : stockValue || "";

      if (vehicle.id) {
        mapById[vehicle.id] = label;
      }
      if (stockValue) {
        mapByStock[normalizeStock(stockValue)] = label;
      }
    });

    return { byId: mapById, byStock: mapByStock };
  };

  const createCustomerMap = (custData) => {
    // console.log("custData", custData);
    return custData.customers.reduce((map, cust) => {
      map[cust.id] = `${cust.Year} ${cust.Make} ${cust.Model} (${cust.Color})`;
      return map;
    }, {});
  };

  const createStepsMap = (steps) => {
    return steps.reduce((map, step) => {
      map[step.id] = `${step.step_name}`;
      return map;
    }, {});
  };

  const findVehicleLabelFromInventory = (inspection) => {
    const targetStock = normalizeStock(inspection.stock);
    const match = fetchedInventory.find(
      (v) =>
        (targetStock &&
          normalizeStock(v.stock || v.Stock) === targetStock) ||
        (inspection.inventory_id && v.id === inspection.inventory_id)
    );
    if (match) {
      const year = match.year || match.Year;
      const make = match.make || match.Make;
      const model = match.model || match.Model;
      const color = match.color || match.Color;
      const ymmbase = [year, make, model]
        .filter(Boolean)
        .join(" ")
        .trim();
      if (ymmbase) {
        return color ? `${ymmbase} (${color})` : ymmbase;
      }
      return match.stock || match.Stock || "";
    }
    return "";
  };

  const locationMap = {
    S01_Holmes1: "Diberville",
    S05_Montgomery1: "Montgomery",
    S07_Bham1: "Birmingham",
    S09_Douglas1: "Douglasville",
  };

  const locationMap2 = {
    1: "S01_Holmes1",
    2: "S09_Douglas1",
    3: "S05_Montgomery1",
    4: "S07_Bham1",
  };

  const fetchInspectionAndUserData = useCallback(async (inspectsOnly = false) => {
    //inspectsOnly is true when called from IncomingTable
    try {
      // ONLY FETCH INSPECTIONS (REFRESH BTN - IncomingTable)
      if (inspectsOnly) {
        const [
          inspectionsResponse,
          inventoryResponse,
          usersResponse,
          stepsResponse,
          customerResponse,
        ] = await Promise.all([
          axios.get(`${apiUrl}/api/inspections`),
          axios.get(`${apiUrl}/api/admin/vehicle/list`),
          axios.get(`${apiUrl}/api/users/list`),
          axios.get(`${apiUrl}/api/steps`),
          axios.get(`${apiUrl}/api/customers`),
        ]);
        const reversedInspections = inspectionsResponse.data.reverse(); //for

        // Step 1: Map user location IDs to their corresponding location names

        const allowedLocations = user.location_id.map(
          (id) => locationMap2[id].trim() // trim to remove spaces
        );

        const emptyMessageLocations = allowedLocations
          .map((location) => locationMap[location])
          .filter(Boolean);

        setEmptyMessageLocations(emptyMessageLocations);

        // Step 2: Filter reversedInspections based on allowedLocations
        const filteredInspections = reversedInspections.filter((insp) =>
          allowedLocations.includes(insp.location)
        );

        // Step 3: Set the filtered inspections to inspectionData
        setInspectionData(filteredInspections);
        setFetchedInventory(inventoryResponse.data);
        setInventoryMap(createInventoryMap(inventoryResponse.data));
        setCustomerMap(createCustomerMap(customerResponse.data));
        setUserMap(createUserMap(usersResponse.data.users));
        setStepsMap(createStepsMap(stepsResponse.data.steps));
      } else {
        // Otherwise, fetch all data, including Inspections
        const [
          inspectionsResponse,
          inventoryResponse,
          usersResponse,
          stepsResponse,
          customerResponse,
        ] = await Promise.all([
          axios.get(`${apiUrl}/api/inspections`),
          // axios.get(`${apiUrl}/api/inspections`, {
          //   params: { locationLabel },
          // }),
          axios.get(`${apiUrl}/api/admin/vehicle/list`),
          axios.get(`${apiUrl}/api/users/list`),
          axios.get(`${apiUrl}/api/steps`),
          axios.get(`${apiUrl}/api/customers`),
        ]);

        const reversedInspections = inspectionsResponse.data.reverse();
        // if (nonAdmin) {
        // Step 1: Map user location IDs to their corresponding location names
        const allowedLocations = user.location_id.map((id) => locationMap2[id]);
		// console.log("allowedLocations", allowedLocations);
        const emptyMessageLocations = allowedLocations
          .map((location) => locationMap[location])
          .filter(Boolean);

        setEmptyMessageLocations(emptyMessageLocations);
        // Step 2: Filter reversedInspections based on allowedLocations
        const filteredInspections = reversedInspections.filter((insp) =>
          allowedLocations.includes(insp.location)
        );

        // Step 3: Set the filtered inspections to inspectionData
        setInspectionData(filteredInspections);
        //Show only location-spectific inspections table to non-admin users (IncomingTable)
        setFetchedInventory(inventoryResponse.data);
        setInventoryMap(createInventoryMap(inventoryResponse.data));
        setCustomerMap(createCustomerMap(customerResponse.data));
        setUserMap(createUserMap(usersResponse.data.users));
        setStepsMap(createStepsMap(stepsResponse.data.steps));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [apiUrl, user.location_id]);

  useImperativeHandle(
    ref,
    () => ({
      fetchInspectionAndUserData,
    }),
    [fetchInspectionAndUserData]
  );

  useEffect(() => {
    if (nonAdmin) {
      fetchInspectionAndUserData(true);
    } else {
      fetchInspectionAndUserData();
    }
  }, [nonAdmin, fetchInspectionAndUserData]);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12;
    const time = `${hours}:${minutes}${ampm}`;
    return `${month}-${day}-${year}, ${time}`;
  }

  /****************** INSPECTION TYPE FILTER BUTTONS ******************/

  const mapSectionFilters = (inspectionTypes) => {
    // console.log("passed inspectionTypes", inspectionTypes); //stepsMap
    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: ".5rem",
        }}
      >
        {/* StepsMap */}
        {inspectionTypes.map((type, index) => {
          // Skip creating a checkbox for 'Initial_Inspection'
          if (type === "Initial_Inspection") return null;

          return (
            <Checkbox
              key={index}
              overrides={{
                BaseCheckbox: {
                  style: {
                    display: "flex",
                  },
                },
                Checkmark: {
                  style: {
                    borderRadius: ".25rem",
                    padding: ".8rem",
                    border: "none",
                    backgroundColor: "darkGrey",
                  },
                },
                Label: {
                  style: {
                    display: "flex",
                    alignItems: "center", // Center text vertically
                    justifyContent: "center", // Center text horizontally (if needed)
                    height: "100%", // Ensure label takes full height for vertical centering
                    padding: "0", // Reset padding if necessary
                  },
                },
              }}
              onChange={(event) => {
                const { checked } = event.target;
                const currentInspectionType = type;

                setSelectedInspectionTypes((prevSelected) => {
                  if (checked) {
                    // If the checkbox is checked, add it to the selected list
                    return [...prevSelected, currentInspectionType];
                  } else {
                    // If unchecked, remove it from the selected list
                    return prevSelected.filter(
                      (t) => t !== currentInspectionType
                    );
                  }
                });
              }}
              checked={selectedInspectionTypes.includes(type)} // Check the box if the type is in the selected array
            >
              {type}
            </Checkbox>
          );
        })}
      </div>
    );
  };

  const mapLocationFilters = (locations, userLocs) => {
    const adjustedUserLocs = userLocs.map((loc) => loc - 1);
    // Filter locations based on indices in userLocs array
    const filteredLocations = locations.filter((_, index) =>
      adjustedUserLocs.includes(index)
    );

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: ".5rem",
        }}
      >
        {filteredLocations.map((location, index) => {
          return (
            <Checkbox
              key={index}
              overrides={{
                BaseCheckbox: {
                  style: {
                    display: "flex",
                  },
                },
                Checkmark: {
                  style: {
                    borderRadius: ".25rem",
                    padding: ".8rem",
                    border: "none",
                    backgroundColor: "darkGrey",
                  },
                },
                Label: {
                  style: {
                    display: "flex",
                    alignItems: "center", // Center text vertically
                    justifyContent: "center", // Center text horizontally (if needed)
                    height: "100%", // Ensure label takes full height for vertical centering
                    padding: "0", // Reset padding if necessary
                  },
                },
              }}
              onChange={(event) => {
                const { checked } = event.target;
                const currentLocation = location;

                setSelectedLocations((prevSelected) => {
                  if (checked) {
                    // If the checkbox is checked, add it to the selected list
                    return [...prevSelected, currentLocation];
                  } else {
                    // If unchecked, remove it from the selected list
                    return prevSelected.filter((t) => t !== currentLocation);
                  }
                });
              }}
              checked={selectedLocations.includes(location)} // Check the box if the location is in the selected array
            >
              {location}
            </Checkbox>
          );
        })}
      </div>
    );
  };

  const handleInitBtnClick = (id) => {
    const matchingRows = inspectionData
      .filter(
        (inspection) =>
          inspection.init_inspect !== null && inspection.inventory_id === id
      )
      .map((inspection) => ({
        inventory_id: id,
        inspection_date: inspection.inspection_date,
        inspector: userMap[inspection.inspector_id] || "Unknown",
        stock: inspection.stock,
        vehicle: inventoryMap[inspection.inventory_id] || "Unknown",
        location: formatLocation(inspection.location),
        description: inspection.description,
        init_inspect: inspection.init_inspect, // Adding init_inspect value
      }));

    if (matchingRows.length === 0) {
      alert("no initial inspections for that vehicle");
      return;
    }
    //create array of this vehicle's inspection object w/ init_inspect value
    setMatchingInitRows(matchingRows.reverse());
    console.log("matchingRows", matchingRows);
    setIsModalOpen(true);
  };

  const formatLocation = (locationString) => {
    return locationMap[locationString] || "Unknown Location";
  };

  const formatDescription = (description) => {
    if (!description) return "No description";

    const [beforeComma, ...afterComma] = description.split(",");
    return `${beforeComma}${
      afterComma.length > 0 ? `,${afterComma.join(",")}` : ""
    }`;
  };

  const handleExcludeAssignRepair = () => {
    setExcludeAssignRepair((prev) => !prev);
  };

  const handleRepairsOnly = () => {
    setRepairsOnly((prev) => !prev);
  };

  const createRows = (inspectionData) => {
	console.log("createRows called with inspectionData:", inspectionData);
    return inspectionData
      .filter((inspection) => {
        // Apply selected inspection and location filters
        const matchesInspectionTypes =
          selectedInspectionTypes.length === 0 ||
          selectedInspectionTypes.includes(stepsMap[inspection.step_id]); /* ||
          selectedInspectionTypes.includes(stepsMap[inspection.next_status]) */

        const matchesLocations =
          selectedLocations.length === 0 ||
          selectedLocations.includes(formatLocation(inspection.location));

        // Exclude "assign_repair" if excludeAssignRepair is true
        const excludeAssignRepairFilter =
          !excludeAssignRepair || inspection.step_id !== 21;

        return (
          matchesInspectionTypes &&
          matchesLocations &&
          excludeAssignRepairFilter
        );
      })
      .map((inspection) => ({
        id: inspection.id,
        data: [
          inspection.id.toString(),
          inspection.inventory_id
            ? inspection.inventory_id.toString()
            : "Unknown",

          formatDate(
            //for UTC conversion from fetch (production)
            new Date(inspection.inspection_date).toLocaleString("en-US", {
              timeZone:
                locationLabel === "Douglasville"
                  ? "America/New_York"
                  : "America/Chicago",
            })
          ),

          userMap[inspection.inspector_id] || "Unknown",
            inspection.stock || "Unknown",
          (() => {
            const byStock = inventoryMap?.byStock || {};
            const byId = inventoryMap?.byId || {};
            const stockKey = normalizeStock(inspection.stock);

            if (stockKey && byStock[stockKey]) {
              return byStock[stockKey];
            }

            if (inspection.inventory_id && byId[inspection.inventory_id]) {
              return byId[inspection.inventory_id];
            }

            if (inspection.custRepairId && customerMap[inspection.custRepairId]) {
              return customerMap[inspection.custRepairId];
            }

            const inventoryMatch = findVehicleLabelFromInventory(inspection);
            if (inventoryMatch) {
              return inventoryMatch;
            }

            const ymmbase = [inspection.year, inspection.make, inspection.model]
              .filter(Boolean)
              .join(" ")
              .trim();
            if (ymmbase) {
              return inspection.color ? `${ymmbase} (${inspection.color})` : ymmbase;
            }

            return inspection.vehicle || inspection.make || "Unknown";
          })(),
          formatLocation(inspection.location),
          stepsMap[inspection.step_id] || "Unknown",
          formatDescription(inspection.description) || "No description",
          stepsMap[inspection.next_status] || "Unknown",
          inspection.init_inspect ? inspection.init_inspect.toString() : "N/A",
          inspection.custRepairId
            ? inspection.custRepairId.toString()
            : "Unknown",
        ],
        // highlighted: highlightedSteps.includes(inspection.step_id),
      }));
  };

  // Create rows by passing all inspection data, with createRows now handling the filtering
  const rows = createRows(inspectionData);
  //rows for Repairs StatefulDataTable being conditionally returned in admin /inspecitons
  const customerRows = rows.filter(
    (row) =>
      row.data[11] !== "Unknown" &&
      row.data[11] !== null &&
      row.data[11] !== "N/A" &&
      row.data[6] === locationLabel
  );

  ////////////// INCOMING JOBS  TABLE
  // console.log("inventoryMap", inspectionData);


  const createJobsRows = (fetchedInventory) => {
    return fetchedInventory.filter((veh) => {
      // Add your filtering condition here
      // Example: return veh.status === 'active';
      return true; // Adjust this line with your actual condition
    });
  };

  // const jobRows = createJobsRows(fetchedInventory); //for IncomingJobs StatefiulDataTable (inventory filtered for locations, of user)
  const columns = [
    StringColumn({
      title: "id",
      maxWidth: 0.25,
      mapDataToValue: (data) => data[0],
      filterable: true,
    }),
    StringColumn({
      title: "Date Submitted",
      maxWidth: 95,
      minWidth: 95,
      mapDataToValue: (data) => data[2],
      filterable: true,
    }),
    StringColumn({
      title: "Inspector",
      maxWidth: 50,
      minWidth: 50,
      mapDataToValue: (data) => data[3],
      filterable: true,
    }),
    StringColumn({
      title: "Stock",
      maxWidth: 37,
      minWidth: 37,
      mapDataToValue: (data) => String(data[4]),
      filterable: true,
    }),
    StringColumn({
      title: "Vehicle",
      mapDataToValue: (data) => data[5],
      filterable: true,
    }),
    StringColumn({
      title: "Location",
      maxWidth: 20,
      minWidth: 20,
      mapDataToValue: (data) => data[6],
      filterable: true,
    }),
    StringColumn({
      title: "Type",
      maxWidth: 60,
      minWidth: 60,
      mapDataToValue: (data) => data[7],
      filterable: true,
    }),
    StringColumn({
      title: "Description",
      maxWidth: 300,
      fillWidth: true,
      lineClamp: 15,
      mapDataToValue: (data) => data[8],
      filterable: true,
      // overflow: "scroll",
      // renderCell: (row) => <ScrollableCell value={row.data[8]} />,
    }),
    StringColumn({
      title: "Next Status",
      maxWidth: 60,
      minWidth: 60,
      mapDataToValue: (data) => data[9],
      filterable: true,
    }),
  ];

  // Conditionally add CustomColumn based on user value
  if (user.role_id === 2) {
    columns.push(
      CustomColumn({
        title: "Initial_Inspect, Edit",
        mapDataToValue: (data) => data,
        renderCell: ({ value }) => {
          const inspection = value;

          return (
            <div /* style={{ maxWidth: "60px", minWidth: "60px" }} */>
              <div
                size={SIZE.compact}
                style={{
                  maxWidth: "150px",
                  minWidth: "150px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  padding: "0rem",
                }}
              >
                {/* if custRepairIdField 's value is 'Unknown', then show the 'Init Inpsects' btn */}
                {inspection[11] === "Unknown" /* there are init inspects */ && (
                  <Button
                    style={{
                      marginBottom: "-.75rem",
                      marginTop: ".25rem",
                      backgroundColor: "blue",
                      color: "white",
                    }}
                    size={SIZE.compact}
                    onClick={() => handleInitBtnClick(parseInt(value[1], 10))}
                  >
                    View Init Inspects
                  </Button>
                )}
                <br />
                <Button
                  size={SIZE.compact}
                  style={{
                    backgroundColor: "grey",
                    color: "white",
                    marginTop:
                      inspection[11] !== "Unknown" ? "-.75rem" : undefined,
                  }}
                  onClick={() => {
                    setEditInspectionObj(inspection);
                    setEditInspectOpen(true);
                  }}
                >
                  Edit Inspection
                </Button>
              </div>
            </div>
          );
        },
      })
    );
  }

  //   console.log("columns from inspections", columns);
  const [isHovered, setIsHovered] = useState(false);

  console.log("emptyMessageLocations", emptyMessageLocations);

  /////////////// COMPONENT RETURN /////////////
  return (
    <>
      {user.role_id === 2 && (
        <>
          <IncomingTableAdmin />
        </>
      )}
      <h1 style={{ fontWeight: user.role_id === 2 ? undefined : 300 }}>
        Inspections
        <span style={{ fontSize: "1.25rem", fontWeight: 300 }}>
          {"    "}
          in {emptyMessageLocations.join(", ")}
          {/* your location(s) */} [{inspectionData.length}]
        </span>
      </h1>

      <Button
        style={{
          color: isHovered ? "white" : "black",
          fontWeight: 400,
          backgroundColor: isHovered ? "black" : "#d3edf1",
          marginBottom: "1.5rem",
          marginRight: "1rem",
          padding: ".5rem",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={() => fetchInspectionAndUserData(true)} // Arrow function added here
      >
        Refresh Inspections
      </Button>

      <Button
        onClick={handleExcludeAssignRepair}
        overrides={{
          BaseButton: {
            style: ({ $theme }) => ({
              backgroundColor: excludeAssignRepair ? "orange" : "	#ffe2b9", // Light blue background
              color: "black", // Adjust text color if needed
              ":hover": {
                color: "white", // Text color on hover
              },
              fontSize: "14px", // Smaller font size
              paddingTop: "6px",
              paddingBottom: "6px",
              paddingLeft: "12px",
              paddingRight: "12px",
            }),
          },
        }}
      >
        {excludeAssignRepair
          ? "INCLUDE assign_repair"
          : "EXCLUDE assign_repair"}
      </Button>
      <Button
        onClick={handleRepairsOnly}
        overrides={{
          BaseButton: {
            style: ({ $theme }) => ({
              backgroundColor: repairsOnly ? "orange" : "	#ffe2b9", // Light blue background
              color: "black", // Adjust text color if needed
              ":hover": {
                color: "white", // Text color on hover
              },
              fontSize: "14px", // Smaller font size
              paddingTop: "6px",
              paddingBottom: "6px",
              paddingLeft: "12px",
              paddingRight: "12px",
              marginLeft: "1rem",
            }),
          },
        }}
      >
        REPAIRS ONLY
      </Button>

      {user.location_id.length > 1 && (
        <>
          {mapLocationFilters(Object.values(locationMap3), user.location_id)}
          <hr />
        </>
      )}

      {mapSectionFilters(Object.values(stepsMap))}
      <div
        className={css({
          height: user.role_id === 2 ? "77vh" : "480px",
          borderRadius: "10px",
          overflow: "hidden",
        })}
      >
        {/****************** INSPECTION TYPE FILTER BUTTONS ******************/}

        <StatefulDataTable
          border="1px solid red"
          columns={columns}
          rows={repairsOnly ? customerRows : rows}
          rowHeight={user.role_id === 2 ? 100 : 70}
          emptyMessage={() =>
            `No inspections found in ${emptyMessageLocations.join(", ")}`
          }
        />

        {isModalOpen && (
          <InitInspectsModal
            isModalOpen={isModalOpen}
            inspections={inspectionData}
            steps={stepsMap}
            users={userMap}
            locations={locationMap}
            onClose={() => setIsModalOpen(false)}
            matchingInitRows={matchingInitRows}
          />
        )}
        {editInspectOpen && (
          <EditInspectModal
            editInspectOpen={editInspectOpen}
            inspections={inspectionData}
            onClose={() => {
              setEditInspectOpen(false); // Close the modal
              // refreshInspections(); // Refresh the inspections data
              fetchInspectionAndUserData();
            }}
            inspectionObj={editInspectionObj}
          />
        )}

        {/* conditional return for the Modal, which is fed the 'matchingInitInspects' object */}
      </div>
    </>
  );
});

export default Inspections;
